import { NgModule } from '@angular/core';
import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRouteGuard } from './shared/common/auth/auth-route-guard';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'app',
                component: AppComponent,
                canActivate: [AppRouteGuard],
                canActivateChild: [AppRouteGuard],
                children: [
                    {
                        path: '',
                        children: [
                            { path: '', redirectTo: '/app/main/my-day', pathMatch: 'full' },
                            { path: 'main', redirectTo: '/app/main/my-day', pathMatch: 'full' },
                            { path: 'main', redirectTo: '/app/main/projects', pathMatch: 'full' },
                            { path: 'main', redirectTo: '/app/main/clients', pathMatch: 'full' }
                        ]
                    },
                    {
                        path: 'main',
                        loadChildren: () => import('app/main/main.module').then(m => m.MainModule), 
                        data: { preload: true }
                    },
                    {
                        path: 'settings',
                        loadChildren: () => import('app/settings/settings.module').then(m => m.SettingsModule), 
                        data: { preload: true }
                    },
                    {
                        path: 'mobile',
                        loadChildren: () => import('app/mobile/mobile.module').then(m => m.MobileModule),
                        data: { preload: true }
                    },
                    {
                        // Adaptive Onboarding (plan §3.2): the full-screen onboarding at /app/onboarding. No permission
                        // data, so AppRouteGuard only checks the session; the onboarding route's own guard (D-08) decides
                        // who may stay. AppComponent hides the sidebar and the shell overlays here (isFullScreenRoute).
                        // Not preloaded: most users never open it.
                        path: 'onboarding',
                        loadChildren: () => import('app/onboarding/onboarding.module').then(m => m.OnboardingModule)
                    }
                ]
            }
        ])
    ],
    exports: [RouterModule]
})

export class AppRoutingModule {
    constructor(
        private router: Router
    ) {
        router.events.subscribe((event) => {
            if (event instanceof RouteConfigLoadStart) {
                //abp.ui.setBusy();
                $('body').append('<div id="loading" style="display: flex; height: 100%; width: 100%; background-color: #fff; position: fixed; top: 0; left: 0; z-index: 9999; align-items: center; justify-content: center;"><div style="display: flex; flex-direction: column; align-items: center; max-width: 20rem; width: 100%; padding: 0 1.5rem;"><div style="margin-bottom: 2.5rem;"><img src="https://cdn.trovve.com/trovve/login-left-logo.png" alt="Trovve" style="height: 2.25rem; object-fit: contain; opacity: 0.2;"></div><div style="display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem;"><p style="font-size: 1rem; color: rgb(31, 41, 55); text-align: center; margin: 0;">Getting things ready\u2026</p></div><div style="width: 100%;"><div style="height: 3px; background: rgb(229, 231, 235); border-radius: 9999px; overflow: hidden; position: relative;"><div class="loading-bar-slider" style="position: absolute; top: 0; bottom: 0; width: 50%; background: rgb(55, 65, 81); border-radius: 9999px;"></div></div></div></div></div>');
            }

            if (event instanceof RouteConfigLoadEnd) {
                //abp.ui.clearBusy();
                $('#loading').remove();
                //$('.company-loader .page-container').show();
            }

            if (event instanceof NavigationEnd) {
                $('meta[property=og\\:url]').attr('content', window.location.href);
            }
        });
    }
}
